var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#0074BD",
    cx: 42.5,
    cy: 42.5,
    r: 42.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.06 63c1.309 0 2.44-.437 3.392-1.31L68.93 31.214c.873-.952 1.31-2.083 1.31-3.393 0-1.31-.457-2.44-1.37-3.392-.913-.953-2.024-1.429-3.333-1.429-1.31 0-2.44.476-3.393 1.429L35 51.57 23.214 39.667c-.952-.953-2.083-1.429-3.393-1.429-1.31 0-2.44.476-3.392 1.429C15.476 40.619 15 41.75 15 43.06c0 1.309.476 2.44 1.429 3.392L31.667 61.69c.952.873 2.083 1.31 3.393 1.31z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
export default SvgSuccessIco;